/**
 * SxaAssessmentStartTile.js
 *
 * Copyright (c) 2018-2019 i-Solutions Global Ltd. All Rights Reserved.
 *
 * This software is the confidential and proprietary information of
 * i-Solutions Global Ltd. ("Confidential Information").  You shall
 * not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered into
 * with i-Solutions Global Ltd.
 *
 * I-SOLUTIONS GLOBAL LTD MAKES NO REPRESENTATIONS OR WARRANTIES ABOUT
 * THE SUITABILITY OF THE SOFTWARE, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT
 * LIMITED TO THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
 * PARTICULAR PURPOSE, OR NON-INFRINGEMENT. I-SOLUTIONS GLOBAL LTD SHALL NOT BE
 * LIABLE FOR ANY DAMAGES SUFFERED BY LICENSEE AS A RESULT OF USING, MODIFYING OR
 * DISTRIBUTING THIS SOFTWARE OR ITS DERIVATIVES.
 *
 * Version 1.0
 */

import React from 'react';
import PropTypes from 'prop-types';

import StratexAssessGroup from './images/inx_group_image.png';
import StratexAssessSlope from './images/inx_slope_grad.svg';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
    welcomelabel: {
        fontSize: 18,
        marginTop: 18,
        marginBottom: 0,
        marginLeft: 20,
        marginRight: 20,
        color: "white"
    },
    getstartedlabel: {
        fontSize: 14,
        marginTop: 4,
        marginBottom: 4,
        marginLeft: 20,
        marginRight: 20,
        color: "#1e2b56"
    },
});

class SxaAssessmentStartTile extends React.Component {
    constructor(props) {
        super(props);
        // Assign A ref to state for refresh
        this.state = { progstate: props.progstate };

        this.handleStartClick = this.handleStartClick.bind(this);
    }

    handleStartClick(e) {
        e.preventDefault();
        console.log("Assessment START clicked");

        // Signal the A container to handle A-state change - callback function
        this.props.signalStart();

        // Call server to start the A (call moved up to signalStart() )
        // FIXME - change to sxa/v1/assessment
        // FIXME - use GET instead of POST to workaround CORS bug in server
        /*var url = 'api/assessment/start';
        axios.get(url)
            .then(response => {
                console.log(response.data);

                // Signal the A container to handle A-state change - callback function
                console.log("Assessment START server call completed");
                this.props.signalStart();
            })
            .catch(err => console.error(err))
        */
    }

    render() {
        const {classes} = this.props;
        return (
            <React.Fragment>
                { this.state.progstate ? (
                    <div style={{marginLeft: 0, marginRight: 0,
                        backgroundImage: `url(${StratexAssessSlope})`,
                        backgroundRepeat: 'no-repeat'}}>
                        <Grid container spacing={0} style={{padding: 0}}
                              direction="row" justify="space-evenly" alignItems="stretch">
                            <Grid item xs={12} sm={12} lg={12} xl={12} align="center">
                                <Typography className={classes.welcomelabel} >
                                    Welcome to StratexAssess, your free strategy execution maturity
                                    assessment tool from i-nexus
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={12} lg={12} xl={12} align="center">
                                <Button onClick={this.handleStartClick} variant="contained" color="primary"
                                        style={{marginRight: 6, marginTop: 14, marginBottom: 10,
                                            backgroundColor: '#1976D2'}}>
                                    Start
                                </Button>
                            </Grid>
                            <Grid item xs={12} sm={12} lg={12} xl={12} align="center">
                                <img src={StratexAssessGroup} alt="Group"
                                     style={{ margin: 0, minHeight: 112, maxHeight: 150}}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} lg={12} xl={12} align="center">
                                <Typography className={classes.getstartedlabel} >
                                    Assess your current strategy execution capabilities and receive
                                    complimentary advice on how to improve your organisation's
                                    capability in the future.
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={12} lg={12} xl={12} align="center">
                                <Typography className={classes.getstartedlabel} >
                                    It only takes 10 minutes to complete the survey, so let's get started!
                                </Typography>
                            </Grid>
                        </Grid>
                    </div>
                ) : "No Assessment ProgressState found"}
            </React.Fragment>
        );
    }
}

SxaAssessmentStartTile.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SxaAssessmentStartTile);